const ProductController = function ($scope, $sce) {
  var normalizeText = function (value) {
    return typeof value === 'string' ? value.trim() : '';
  };

  var getDetailData = function (product) {
    return product && product.detailData ? product.detailData : null;
  };

  /**
   * @param {Product} product
   * @return {string}
   */
  $scope.getDescription = function (product) {
    var description = '';
    if (product.detailData && product.detailData.beschreibung) {
      description = $sce.trustAsHtml(product.detailData.beschreibung);
    }
    return description;
  };

  $scope.getActivePicture = function (product) {
    return product.activeImage ? product.activeImage : product.image;
  };

  $scope.getProductImages = function (product) {
    var images = [];
    var detailData = getDetailData(product);
    var imageSrc = '';

    if (!product) {
      return images;
    }

    if (detailData) {
      imageSrc = normalizeText(detailData.prod_img_1);
      if (imageSrc) {
        images.push(imageSrc);
      }
      imageSrc = normalizeText(detailData.prod_img_2);
      if (imageSrc) {
        images.push(imageSrc);
      }
      imageSrc = normalizeText(detailData.prod_img_3);
      if (imageSrc) {
        images.push(imageSrc);
      }
    }

    if (!images.length && product && product.image) {
      imageSrc = normalizeText(product.image);

      if (imageSrc) {
        images.push(imageSrc);
      }
    }

    return images;
  };

  $scope.hasMultipleProductImages = function (product) {
    return $scope.getProductImages(product).length > 1;
  };

  $scope.isActivePicture = function (product, img) {
    return normalizeText($scope.getActivePicture(product)) === normalizeText(img);
  };

  $scope.getPicturePanelId = function (product) {
    return 'cross-sell-image-panel-' + product.id;
  };

  $scope.getPictureTabId = function (product, index) {
    return 'cross-sell-image-tab-' + product.id + '-' + index;
  };

  $scope.getActivePictureTabId = function (product) {
    var images = $scope.getProductImages(product);
    var activeImage = $scope.getActivePicture(product);
    var activeIndex = -1;
    var i = 0;

    for (i = 0; i < images.length; i++) {
      if (images[i] === activeImage) {
        activeIndex = i;
        break;
      }
    }

    if (!images.length) {
      return null;
    }

    return $scope.getPictureTabId(product, activeIndex > -1 ? activeIndex : 0);
  };

  $scope.getPictureTabIndex = function (product, img) {
    return $scope.isActivePicture(product, img) ? 0 : -1;
  };

  $scope.getPictureImageIndex = function (product, img) {
    var images = $scope.getProductImages(product);
    var imageIndex = -1;
    var i = 0;

    for (i = 0; i < images.length; i++) {
      if (images[i] === img) {
        imageIndex = i;
        break;
      }
    }

    return imageIndex > -1 ? imageIndex + 1 : 1;
  };

  $scope.getPictureImageAltText = function (product, img) {
    var detailData = getDetailData(product);
    var imageSrc = normalizeText(img);
    var imageAlt = '';

    if (detailData) {
      if (normalizeText(detailData.prod_img_1) === imageSrc) {
        imageAlt = normalizeText(detailData.prod_alt_1);
      } else if (normalizeText(detailData.prod_img_2) === imageSrc) {
        imageAlt = normalizeText(detailData.prod_alt_2);
      } else if (normalizeText(detailData.prod_img_3) === imageSrc) {
        imageAlt = normalizeText(detailData.prod_alt_3);
      }
    }

    if (imageAlt) {
      return imageAlt;
    }

    return normalizeText(product && product.name);
  };

  $scope.setActivePicture = function (product, img) {
    product.activeImage = normalizeText(img);
    return this;
  };

  $scope.onProductImageTabKeydown = function (product, currentIndex, $event) {
    var images = $scope.getProductImages(product);
    var nextIndex = null;

    if (images.length <= 1) {
      return;
    }

    switch ($event.key) {
      case 'ArrowUp':
      case 'ArrowLeft':
        nextIndex = currentIndex > 0 ? currentIndex - 1 : images.length - 1;
        break;
      case 'ArrowDown':
      case 'ArrowRight':
        nextIndex = currentIndex < images.length - 1 ? currentIndex + 1 : 0;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = images.length - 1;
        break;
      default:
        return;
    }

    $event.preventDefault();
    $scope.setActivePicture(product, images[nextIndex]);

    window.requestAnimationFrame(function () {
      var nextTab = document.getElementById($scope.getPictureTabId(product, nextIndex));

      if (nextTab) {
        nextTab.focus();
      }
    });
  };

};

export default ProductController;
